"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OVERVIEW_SWITCH = void 0;
const OVERVIEW_SWITCH = exports.OVERVIEW_SWITCH = 'overview-switch';
